/*
    * 이미지가 있는 버전 2 인트로 페이지
 */
<template>
  <div class="Iwrap">
        <div class="Ihader"></div>
        <div class="Icontent" >
            <div class="Iinner">
                <!-- <div class="backgroundImg"></div> -->
                <img :src="introImagePath">
                <div class="backgroundImgqr"></div>
            </div>
        </div>
        <div class="Ifooter">
            <div class="Iinner">
                <p>{{introStoreName}}</p>
                <div class="ftlogo"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'TYPE_TWO_INTRO',
  data () {
    return {
      introImagePath: this.$store.getters.imagePath,
      introStoreName: this.$store.getters.name
    }
  }
}
</script>

<style scoped>
    img{
        width: 100%;
        height: calc(100vh - 200px);
        object-fit: cover;
    }
</style>
